
define(
	'Digi.DigiConfigSettings.DigiConfigSettings',
	[],
	function ()
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application) {

			var MyAccountMenuModule;
			var MyAccountMenu;
			var menu;
			var configuration;
			var environment;
			var myaccount;
			var customEmailPreferencesMenu;
			var customEmailPreferencesLabel;

			environment = application.getComponent('Environment');
			configuration = environment.getConfig('digiConfigSettings');

			MyAccountMenuModule = require('MyAccountMenu');
			MyAccountMenu = MyAccountMenuModule.MyAccountMenu || MyAccountMenuModule;

			customEmailPreferencesLabel = configuration && configuration.myaccount && configuration.myaccount.customEmailPrefLabel;

			if (MyAccountMenu && _.isFunction(MyAccountMenu.getInstance)) {
				menu = MyAccountMenu.getInstance()
			} else {
				console.error('MyAccountMenu is missing');
			}

			if (customEmailPreferencesLabel && menu) {

				menu.removeSubEntry('emailpreferences');

				myaccount = application.getComponent("MyAccountMenu");
				customEmailPreferencesMenu = {
					id: "emailpreferences",
					groupid: "settings",
					name: customEmailPreferencesLabel,
					index: 1,
					url: "emailpreferences"
				}

				myaccount.addGroupEntry(customEmailPreferencesMenu);
			}
		}
	};
});
